import React from 'react';
import styles from './index.module.css';

const ProgressBar = ({ current, total }) => {
  const safeTotal = Math.max(total || 0, 1);
  const clamped = Math.min(Math.max(current || 0, 0), safeTotal);
  const pct = (clamped / safeTotal) * 100;
  return (
    <div
      className={styles.track}
      role='progressbar'
      aria-valuenow={clamped}
      aria-valuemin={0}
      aria-valuemax={safeTotal}
      aria-label={`Question ${clamped} of ${safeTotal}`}
    >
      <div className={styles.fill} style={{ width: `${pct}%` }} />
    </div>
  );
};

export default ProgressBar;
